<template>
  <PForm
    ref="pForm"
    :heading="heading"
    :primary-cta="submitButton"
    :secondary-cta="secondaryCta"
    @close="closeForm"
  >
    <PMarkupTable
      class-name="full-width"
      :columns="columns"
      :rows="rows"
      flat
      :hide-header="hideHeader"
    />
  </PForm>
</template>

<script setup>
const submitButton = ref({});
const secondaryCta = ref({});

const hideHeader = computed(() => {
  return props.type === "files";
});

const { togglePastPaymentRequestsView } = usePaymentRequestStore();

const props = defineProps({
  heading: {
    type: String,
    required: true,
  },
  columns: {
    type: Array,
    required: true,
  },
  rows: {
    type: Array,
    required: true,
  },
  type: {
    type: String,
    default: "",
  },
});

const closeForm = () => {
  togglePastPaymentRequestsView({
    open: false,
  });
};
</script>
